import { DatePicker } from "antd"
import locale from "antd/es/date-picker/locale/ar_EG"
import { useSelector } from "react-redux"
import DateTime from "../../../utils/dateTime"

const MonthPicker = ({
  value,
  onChange,
  disabledDate,
  containerWidth = "16ch",
  format,
  noCurrentMonth = false,
  ...rest
}) => {
  const { locale: appLanguage } = useSelector(state => state.app.configs)
  const getCurrentMonth = () => {
    const date = new Date()
    date.setDate(1)
    return date
  }
  return (
    <div style={{ width: containerWidth }}>
      <DatePicker
        value={
          value ? DateTime.getDateAndTime(value) : noCurrentMonth ? null : DateTime.getDateAndTime(getCurrentMonth())
        }
        onChange={onChange}
        format={format || "MMMM YYYY"}
        picker="month"
        disabledDate={disabledDate}
        allowClear={false}
        locale={appLanguage === "en" ? [] : locale}
        {...rest}
      />
    </div>
  )
}

export default MonthPicker
